<template>
  <ChartTimeseries
    :data="chartData"
    :layout="computedLayout"
    @hover="setCurrentPower"
  ></ChartTimeseries>
</template>

<script>
import deepmerge from "deepmerge";

export default {
  name: "ApparentPowerTimeseries",
  components: {
    ChartTimeseries: () => import("@/components/charts/ChartTimeseries.vue"),
  },
  mixins: [],
  props: {
    activePower: { required: true },
    reactivePower: { required: true },
    layout: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      hover: { active: 3, reactive: 4 },
    };
  },
  computed: {
    computedLayout() {
      return deepmerge(
        {
          xaxis: { domain: [0, 0.6] },
          yaxis2: {
            scaleanchor: "x2",
            anchor: "x2",
            range: this.layout.yaxis.range,
            title: {
              text: "Reactive Power",
              font: { size: 10 },
            },
          },
          xaxis2: {
            constrain: "domain",
            domain: [0.7, 1],
            range: this.layout.yaxis.range,
            title: {
              text: "Active Power",
              font: { size: 10 },
            },
          },
          shapes: [
            ...[0.4, 0.6, 0.8, 1]
              .map((v) => v * this.layout.yaxis.range[1] - 1)
              .map((v) => ({
                type: "circle",
                xref: "x2",
                yref: "y2",
                x0: v,
                y0: v,
                x1: -v,
                y1: -v,
                line: {
                  color: "#dadada",
                  width: 1,
                },
              })),
            {
              type: "circle",
              xref: "x2",
              yref: "y2",
              x0: this.layout.yaxis.range[1] - 1,
              y0: this.layout.yaxis.range[1] - 1,
              x1: -this.layout.yaxis.range[1] + 1,
              y1: -this.layout.yaxis.range[1] + 1,
              line: {
                width: 1,
                color: "#cacaca",
              },
            },
          ],
          annotations: [
            {
              x: this.hover.reactive,
              y: this.hover.active,
              xref: "x2",
              yref: "y2",
              ax: 0,
              axref: "x2",
              ay: 0,
              ayref: "y2",
              arrowcolor: "#2ca02c",
            },
            {
              xref: "paper",
              yref: "paper",
              x: 1,
              xanchor: "right",
              y: 1,
              yanchor: "bottom",
              text: `Apparent Power [MVA]: ${this.currentApparentPower}`,
              showarrow: false,
            },
          ],
        },
        this.layout
      );
    },
    chartData() {
      return [
        {
          name: "Active Power",
          ...this.activePower,
          line: {
            shape: "hv",
          },
        },
        {
          name: "Reactive Power",
          ...this.reactivePower,
          line: {
            shape: "hv",
          },
        },
        {
          name: "Apparent Power",
          x: this.activePower.x,
          y: this.combineChartData(
            (a, b) => Math.sqrt(a ** 2 + b ** 2),
            this.activePower.y,
            this.reactivePower.y
          ),
          line: {
            shape: "hv",
          },
        },
      ];
    },
    currentApparentPower() {
      return this.$utils.formatNumberD3(
        Math.sqrt(this.hover.active ** 2 + this.hover.reactive ** 2)
      );
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    setCurrentPower($e) {
      this.hover.active = $e.points[0].y;
      this.hover.reactive = $e.points[1].y;
    },
    combineChartData(fn, data1, data2) {
      return data1.map((v, i) => fn(v, data2[i]));
    },
  },
};
</script>

<style></style>
